import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17b2aad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box flex" }
const _hoisted_2 = { class: "search-box" }
const _hoisted_3 = {
  key: 0,
  class: "search-result"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["title"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "select-result" }
const _hoisted_8 = ["onClick", "onMouseenter", "onMouseleave"]
const _hoisted_9 = { class: "address" }
const _hoisted_10 = { style: {"margin-left":"10px"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "container" }, null, -1))

import AMapLoader from '@amap/amap-jsapi-loader'
import { reactive, ref, watch, PropType, onUnmounted, onMounted } from 'vue'
import type { SystemSetting } from '@/types/systemSetting'
import { cloneDeep } from 'lodash-es'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  editData: {
    type: Object as PropType<any>,
    default: () => {
      return {}
    }
  }
},
  emits: ['mapData'],
  setup(__props, { emit: __emit }) {

const img = require('@/assets/index/poi-marker-red.png')
const img2 = require('@/assets/index/poi-marker-default.png')
const emit = __emit
const props = __props
// 实例化点标记
const map = ref()
const AMapNew = ref()
const placeSearch = ref()
const infoWindow = ref()
const geocoder = ref()
const searchMarker = ref<any>([])
const marker = ref()
const locationData = reactive<any>({
  latAndLong: [],
  address: ''
})

const showResult = ref(false)
const upResult = ref(true)
const listIndex = ref(-1)

const keyWord = ref()
const poisList = ref([])
const selectList = ref<any[]>([])

watch(
  () => props.editData,
  (v) => {
    if (v.geoPoint) {
      const { longitude, latitude } = v.geoPoint
      if (longitude && longitude !== -9) {
        locationData.latAndLong = [longitude, latitude]
        locationData.address = v.address
      }
    }
  },
  { immediate: true }
)
// 添加点标记
const addMarker = (option: any, showInfo = true) => {
  marker.value = new AMapNew.value.Marker({
    icon: new AMapNew.value.Icon({
      image: img2,
      size: new AMapNew.value.Size(28, 35),
      imageSize: new AMapNew.value.Size(28, 35)
    }),
    position: [option.location.KL, option.location.kT],
    offset: new AMapNew.value.Pixel(-13, -30)
  })
  marker.value.setMap(map.value)
  if (showInfo) {
    marker.value.on('mouseover', () => {
      showInfoOver([option.location.KL, option.location.kT], option.name)
    })
  }
  // 是否需要居中放大显示
  map.value.setFitView()
}
// 确认选中
const setAddress = (option: any) => {
  locationData.address = `${option.pname}${option.cityname}${option.adname}${option.address}${option.name}`
  locationData.latAndLong = [option.location.KL, option.location.kT]
  emit('mapData', locationData)
}
// Map搜索地标详情
const getAddressByLat = (option: any) => {
  // 取详情
  geocoder.value.getAddress([option.location.KL, option.location.kT], function (status: string, result: any) {
    if (status === 'complete' && result.info === 'OK') {
      console.log(result)
      locationData.address = result.regeocode.formattedAddress
      locationData.latAndLong = [option.location.KL, option.location.kT]
      emit('mapData', locationData)
    }
  })
}
// 删除点标记
const clearMarker = () => {
  if (marker.value) {
    marker.value.setMap(null)
    marker.value = null
  }
}
// 进行地图初始化
function initMap() {
  AMapLoader.load({
    key: '7b8cdefc3a9ad93469dde19fe05c182a', // 申请好的Web端开发者Key，首次调用 load 时必填
    version: '2.0'
  }).then((AMap) => {
    AMapNew.value = AMap
    const { latAndLong } = locationData
    map.value = new AMap.Map('container', {
      // 设置地图容器id
      viewMode: '3D', // 是否为3D地图模式
      zoom: 12, // 初始化地图级别
      animateEnable: false,
      center: latAndLong && latAndLong.length ? latAndLong : [114.05799949921004, 22.544114459133812]
    })
    // 添加插件
    AMap.plugin(['AMap.PlaceSearch', 'AMap.Geocoder'], function () {
      placeSearch.value = new AMap.PlaceSearch({
        city: '深圳',
        extensions: 'all'
      })
      geocoder.value = new AMap.Geocoder({})
      // 设置初始值locationData.latAndLong
      const { latAndLong } = locationData
      if (latAndLong?.length > 0) {
        const option = {
          location: {
            KL: latAndLong[0],
            kT: latAndLong[1]
          }
        }
        addMarker(option, false)
      }
    })
    // 单击
    map.value.on('click', (e: SystemSetting.MapLocation) => {
      clearMarker()
      const { KL, kT } = e.lnglat
      const option = {
        location: {
          KL,
          kT
        }
      }
      addMarker(option, false)
      getAddressByLat(option)
    })
    // dragend 拖拽隐藏搜索结果
    map.value.on('dragend', () => {
      upResult.value = false
    })
  })
}

// 显示信息窗体
const showInfoOver = (position: any, content: string) => {
  if (infoWindow.value) {
    infoWindow.value.setContent(content)
  } else {
    infoWindow.value = new AMapNew.value.InfoWindow({
      content,
      offset: new AMapNew.value.Pixel(-4, -30)
    })
  }
  infoWindow.value.open(map.value, position)
}
// 点标记和搜索结果鼠标移入事件

// 搜索点标签确定选中
const searchMarkerClick = (option: any) => {
  keyWordSelect(option)
}
const maskContent = (i: number, type: 'red' | 'default') => {
  const marker1 =
    '<div class="search-marker">' +
    '   <img src="' +
    img +
    '">' +
    '   <div class="search-marker-index">' +
    (i + 1) +
    '</div>' +
    '</div>'
  const marker2 =
    '<div class="search-marker">' +
    '   <img src="' +
    img2 +
    '">' +
    '   <div class="search-marker-index">' +
    (i + 1) +
    '</div>' +
    '</div>'
  return type === 'red' ? marker1 : marker2
}
// 批量添加点标记
const addMoreMarker = (markers: any) => {
  searchMarker.value = []
  markers.forEach((marker: any, i: number) => {
    const marker1 = maskContent(i, 'red')
    const marker2 = maskContent(i, 'default')
    const mark = new AMapNew.value.Marker({
      map: map.value,
      content: marker1,
      position: marker.position,
      offset: new AMapNew.value.Pixel(-12, -30)
    })
    mark.on('mouseover', () => {
      showInfoOver(marker.position, marker.name)
      mark.setContent(marker2)
      // 添加列表样式
    })
    mark.on('mouseout', () => {
      mark.setContent(marker1)
      listIndex.value = -1
    })
    mark.on('click', () => {
      searchMarkerClick(marker)
    })
    searchMarker.value.push(mark)
  })
  map.value.setFitView()
}
// 搜索
const keyWordSearch = () => {
  if (!keyWord.value) {
    poisList.value = []
    searchMarker.value && map.value.remove(searchMarker.value)
    infoWindow.value && infoWindow.value.close()
  }
  showResult.value = false
  placeSearch.value.search(keyWord.value, function (status: any, result: any) {
    if (result.poiList && result.poiList.pois) {
      // 过滤没有坐标的点
      poisList.value = result.poiList.pois.filter(
        (item: any) => item.location && item.location.lat && item.location.lng
      )
    }
  })
}
// 确认搜索结果选中
const keyWordSelect = (option: any) => {
  clearMarker()
  keyWord.value = option.name
  addMarker(option)
  setAddress(option)
}
// enter
const keyWordEnter = (arr: any) => {
  map.value.remove(searchMarker.value)
  setTimeout(() => {
    showResult.value = true
    upResult.value = true
    selectList.value = cloneDeep(arr)
    const list = arr.map((item: any) => {
      return {
        position: [item.location.KL, item.location.kT],
        ...item
      }
    })
    addMoreMarker(list)
  })
}
// 搜索直接选中
const searchSelect = (option: any) => {
  keyWordEnter([option])
  setTimeout(() => {
    keyWordSelect(option)
  })
}
// 列表mouseover
const listMouseoverOut = (option: any, listNum: number, type: 'enter' | 'leave') => {
  const { kT, KL } = option.location
  const index = searchMarker.value.findIndex((item: any) => item._position[0] === KL && item._position[1] === kT)
  if (index !== -1) {
    if (type === 'enter') {
      showInfoOver([KL, kT], option.name)
      const marker2 = maskContent(index, 'default')
      searchMarker.value[index].setContent(marker2)
      listIndex.value = listNum
    } else {
      const marker1 = maskContent(index, 'red')
      searchMarker.value[index].setContent(marker1)
      listIndex.value = -1
    }
  }
}
// 添加列表的选中样式
onMounted(() => {
  initMap()
})
onUnmounted(() => {
  map.value?.destroy()
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_input, {
          value: keyWord.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keyWord).value = $event)),
          placeholder: "请输入",
          style: {"width":"400px"},
          onChange: keyWordSearch,
          onPressEnter: _cache[1] || (_cache[1] = ($event: any) => (keyWordEnter(poisList.value))),
          allowClear: ""
        }, null, 8, ["value"]),
        (!showResult.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(poisList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex",
                  key: index,
                  onClick: ($event: any) => (searchSelect(item))
                }, [
                  _createElementVNode("p", null, _toDisplayString(item.name), 1),
                  _createElementVNode("p", {
                    class: "address",
                    title: `${item.pname}${item.cityname}${item.adname}${item.address}`
                  }, _toDisplayString(`${item.pname}${item.cityname}${item.adname}${item.address}`), 9, _hoisted_5)
                ], 8, _hoisted_4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      onClick: ($event: any) => (keyWordSelect(item)),
                      onMouseenter: ($event: any) => (listMouseoverOut(item, index, 'enter')),
                      onMouseleave: ($event: any) => (listMouseoverOut(item, index, 'leave')),
                      class: _normalizeClass({ 'select-result-active': listIndex.value === index })
                    }, [
                      _createElementVNode("span", null, _toDisplayString(`${index + 1}.${item.name}`), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString(item.address), 1)
                    ], 42, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vShow, upResult.value]
                ]),
                (!upResult.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (upResult.value = true)),
                      class: "amap-search-panctrl"
                    }, "展开搜索结果"))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]),
      _createElementVNode("p", _hoisted_10, "地址：" + _toDisplayString(locationData.address || '--'), 1)
    ]),
    _hoisted_11
  ], 64))
}
}

})